import { render, staticRenderFns } from "./managementAdd.vue?vue&type=template&id=4a1bd83f&scoped=true&"
import script from "./managementAdd.vue?vue&type=script&lang=js&"
export * from "./managementAdd.vue?vue&type=script&lang=js&"
import style0 from "./managementAdd.vue?vue&type=style&index=0&id=4a1bd83f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bd83f",
  null
  
)

export default component.exports